import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  useMediaQuery,
  Snackbar,
  Alert,
  Slide,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import AnseraLogo from "assets/images/Anser.png";
import axios from "axios";
import { FAST_API_BASE_URL } from "constants";
import { set } from "date-fns";
import { use } from "react";
import { API_BASE_URL } from "constants";
import { useAuth } from "context/AuthContext";

const EmailTemplate = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [form, setForm] = useState({
    emailPlaceholder: "",
    emailHeader:
      "",
    emailFooter:
      "",
  });
  const [initialSettings, setInitialSettings] = useState({
    emailPlaceholder: "",  
    emailHeader: "",
    emailFooter: "",  
  });

      const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
     const { currentDomain } = useAuth();
    const domainId = currentDomain?.domain_token;

   useEffect(() => {
    const getSettings=async ()=>{
      try{
      const res= await axios.get(`${FAST_API_BASE_URL}/api/settings`,
        {
          headers: {
            'Content-Type': 'application/json',
            'DOMAIN-TOKEN': domainId,
          },  
    });
    const settings = res.data.result.ansera_search_chat_curl[0];
    setForm({
      emailPlaceholder: settings.ansera_search_email_placeholder || "",
      emailHeader: settings.email_header || "",
      emailFooter: settings.email_footer || "",
    });
    setInitialSettings({
      emailPlaceholder:settings.ansera_search_email_placeholder || "",
      emailHeader: settings.email_header || "",
      emailFooter: settings.email_footer || "",
    })
    }catch(err){
      console.error("Error fetching settings:", err);
      }
    }
    getSettings();
  }, [domainId]);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }; 

  const handleSave= async () => {
      if(!initialSettings){
        return null;
      }
      const payload = {};
      if (form.emailPlaceholder !== initialSettings.emailPlaceholder) {
        payload.ansera_search_email_placeholder = form.emailPlaceholder;
      } 
      if (form.emailHeader !== initialSettings.emailHeader) {
        payload.email_header = form.emailHeader;
      }
      if (form.emailFooter !== initialSettings.emailFooter) {
        payload.email_footer = form.emailFooter;
      }

      try {
        if (Object.keys(payload).length > 0) {
        await axios.patch(`${FAST_API_BASE_URL}/api/settings`, payload, {
          headers: {
            'Content-Type': 'application/json',
            'DOMAIN-TOKEN': domainId,
          },
        });
      }
       setSnackbarMessage("Settings updated successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setInitialSettings({ ...form });
      } catch (error) {
             console.error("Failed to save settings:", error);
       setSnackbarMessage("Failed to save Settings!");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);;
      }

  }
      const hasChanges =
    JSON.stringify(form) !== JSON.stringify(initialSettings);

         const renderRow = (label, field) => (
           <SoftBox
             display="flex"
             flexDirection={isMobile ? "column" : "row"}
             gap={2}
             alignItems={isMobile ? "flex-start" : "center"}
             mb={1.5}
           >
             <SoftTypography
               width={isMobile ? "100%" : "240px"}
               fontSize="0.875rem"
               fontWeight="medium"
             >
               {label}
             </SoftTypography>
             <SoftBox flex={1}>{field}</SoftBox>
           </SoftBox>
         );
         
        return (
          <SoftBox
            sx={{
              backgroundColor: "#fff",
              p: isMobile ? 2 : 4,
              borderRadius: "16px",
              boxShadow: "0px 6px 20px rgba(0,0,0,0.06)",
            }}
            display="flex"
            flexDirection="column"
            gap={2.5}
          >
                <Snackbar
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={() => setSnackbarOpen(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            TransitionComponent={(props) => <Slide {...props} direction="top" />}
          >
            <Alert
              onClose={() => setSnackbarOpen(false)}
              severity={snackbarSeverity}
              variant="filled"
              sx={{
                width: "100%",
                color: "#ffffff",
                backgroundColor:
                  snackbarSeverity === "success"
                    ? "#008080" 
                    : snackbarSeverity === "error"
                    ? "#d32f2f"
                    : undefined, 
              }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>


        <SoftBox display="flex" alignItems="center" gap={1}>
          <img src={AnseraLogo} alt="Ansera Logo" width={64} />
          <SoftTypography variant="h6" fontWeight="bold">
            Email Template
          </SoftTypography>
        </SoftBox>

        <SoftTypography
          variant="body2"
          color="text.secondary"
          sx={{
            borderBottom: "1px solid #e0e0e0",
            pb: 1,
          }}
        >
          Personalize the email that sends chat history to your users.
        </SoftTypography>

        {renderRow(
          "Email Input Placeholder",
          <TextField
            name="emailPlaceholder"
            value={form.emailPlaceholder}
            onChange={handleChange}
            size="small"
            fullWidth
          />
        )}

        {renderRow(
          "Email Template Header",
          <TextField
            name="emailHeader"
            value={form.emailHeader}
            onChange={handleChange}
            multiline
            rows={3}
            fullWidth
          />
        )}

        {renderRow(
          "Email Template Footer",
          <TextField
            name="emailFooter"
            value={form.emailFooter}
            onChange={handleChange}
            multiline
            rows={3}
            fullWidth
          />
        )}


        <SoftBox mt={1}>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!hasChanges}
            sx={{
              backgroundColor: "#219297",
              color: "#fff",
              textTransform: "none",
              fontSize: "0.875rem",
              fontWeight: 600,
              px: 3,
              py: 1,
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#1a767a",
              },
            }}
          >
            Save Changes
          </Button>
        </SoftBox>
      </SoftBox>
  );  
};  

export default EmailTemplate;
